let cities = {};
export default function getCities(){
    return cities;
}
export function setCities(cities){
    cities = cities;
}